import React from 'react';

import * as S from './styles';

const listQuestions = {
  questionOne: {
    options: [
      {
        id: 1,
        img: <S.ImgNote1 />,
        alt: 'Escala 1',
      },

      {
        id: 2,
        img: <S.ImgNote2 />,
        alt: 'Escala 2',
      },

      {
        id: 3,
        img: <S.ImgNote3 />,
        alt: 'Escala 3',
      },

      {
        id: 4,
        img: <S.ImgNote4 />,
        alt: 'Escala 4',
      },

      {
        id: 5,
        img: <S.ImgNote5 />,
        alt: 'Escala 5',
      },

      {
        id: 6,
        img: <S.ImgNote6 />,
        alt: 'Escala 6',
      },

      {
        id: 7,
        img: <S.ImgNote7 />,
        alt: 'Escala 7',
      },

      {
        id: 8,
        img: <S.ImgNote8 />,
        alt: 'Escala 8',
      },

      {
        id: 9,
        img: <S.ImgNote9 />,
        alt: 'Escala 9',
      },

      {
        id: 10,
        img: <S.ImgNote10 />,
        alt: 'Escala 10',
      },
    ],
  },

  equalQuestion: [
    {
      id: 2,
      title: 'Quão fácil foi contratar nossos serviços?',
      radios: [
        { value: 'Pouco Fácil', label: 'Pouco fácil' },
        { value: 'Fácil', label: 'Fácil' },
        { value: 'Muito Fácil', label: 'Muito fácil' },
      ],
      valueRadio: 'question2Radio',
      valueText: 'question2Text',
    },

    {
      id: 3,
      title: 'Como você avalia o atendimento da CredPago?',
      radios: [
        { value: 'Péssimo', label: 'Péssimo' },
        { value: 'Bom', label: 'Bom' },
        { value: 'Ótimo', label: 'Ótimo' },
      ],
      valueRadio: 'question3Radio',
      valueText: 'question3Text',
    },

    {
      id: 4,
      title: 'Qual a probabilidade utilizar CredPago em uma nova locação?',
      radios: [
        { value: 'Pouco Provável', label: 'Pouco Provável' },
        { value: 'Provável', label: 'Provável' },
        { value: 'Muito Provável', label: 'Muito Provável' },
      ],
      valueRadio: 'question4Radio',
      valueText: 'question4Text',
    },

    {
      id: 5,
      title: 'Como você avalia o atendimento da sua Imobiliária?',
      radios: [
        { value: 'Péssimo', label: 'Péssimo' },
        { value: 'Bom', label: 'Bom' },
        { value: 'Ótimo', label: 'Ótimo' },
      ],
      valueRadio: 'question5Radio',
      valueText: 'question5Text',
    },
  ],
};

export default listQuestions;
